<template>
  <LeadStatusesPage
    :title="`${__('bloqueio', 'settings')} - ${__(
      'automatização',
      'settings'
    )}`"
    :description="
      __('define quais status são bloqueados para automatização', 'settings')
    "
    param-id="leads_block_statuses_automation"
  />
</template>

<script>
import LeadStatusesPage from "@/components/Lead/Statuses/LeadStatusesPage.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  components: {
    LeadStatusesPage,
  },
};
</script>
